import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackEvent } from 'dibs-tracking';

import ArrowSvgRight from 'dibs-vg/dist/react/arrow-right';
import FavNotificationsTileItem from './FavNotificationsTileItem';
import FavNotificationsTileHeader from './FavNotificationsTileHeader';
import FavNotificationsTileDescription from './FavNotificationsTileDescription';

import { ITEM_EVENT, FOLLOWING_TYPE_SEARCH } from './favNotificationsConstants';
import { getNotificationClickedTrackingObj } from './trackingHelpers.es';
import style from './FavNotificationsTile-style.scss';

const getTilePage = tile => {
    const { type, page, items, followingType } = tile;

    if (!page && type === ITEM_EVENT && items) {
        return items[0].pdpURL;
    }

    if (followingType === FOLLOWING_TYPE_SEARCH) {
        const delimiter = page.indexOf('?') > 0 ? '&' : '?';
        return `${page}${delimiter}sort=newest`;
    }

    return page;
};

class FavNotificationsTile extends Component {

    constructor() {
        super();

        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        const { tile, favoritesUrl } = this.props;
        const { eventType, type } = tile;
        trackEvent(getNotificationClickedTrackingObj(eventType || type));

        if (event.target.tagName !== 'A') {
            const tilePage = getTilePage(tile) || favoritesUrl;
            if (tilePage) {
                window.location.href = tilePage;
            }
        }
    }

    render() {
        const { tile } = this.props;
        const { type, items = [], totalResults = 0 } = tile;
        const moreItemsCount = totalResults - items.length;
        const containerClasses = `${style.container} ${style.notEmptyState}`;

        if (!items.length) {
            return null;
        }

        return (
            <div className={containerClasses} onClick={this.onClick}>
                <FavNotificationsTileHeader tile={tile} />
                <div className={style.itemsContainer}>
                    {items.map(item =>
                        <FavNotificationsTileItem key={item.serviceId} item={item} />
                    )}
                    {type === ITEM_EVENT && <FavNotificationsTileDescription tile={tile} />}
                    <div className={style.linkContainer}>
                        {moreItemsCount > 0 && `+${moreItemsCount}`}
                        <ArrowSvgRight className={style.arrow} />
                    </div>
                </div>
            </div>
        );
    }
}

FavNotificationsTile.propTypes = {
    tile: PropTypes.object.isRequired,
    favoritesUrl: PropTypes.string
};

FavNotificationsTile.defaultProps = {
    favoritesUrl: null
};

export default createFragmentContainer(
    FavNotificationsTile,
    {
        tile: graphql`
            fragment FavNotificationsTile_tile on FavoriteNotification {
                type
                eventType
                followingType
                page
                totalResults
                items {
                    serviceId
                    pdpURL
                    ...FavNotificationsTileItem_item
                }
                ...FavNotificationsTileHeader_tile
                ...FavNotificationsTileDescription_tile
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTile.jsx